export default __webpack_public_path__ + "static/media/audio-icon-active.bf3690a4.svg";